/// signout current account

import { browser } from '$app/environment';
import { Auth } from 'aws-amplify';
import { useAccount } from './account';

export const signout = async () => {
	if (!browser) return;

	try {
		await Auth.signOut();

		// close account to guest mode
		const { account } = useAccount();
		account.set(null);

		// clear account
	} catch (error) {
		console.log('error signing out: ', error);
	}
};
